<template>
    <div class="eu-cookie-bar-notification" v-if="showCookie">
        <b-container>
            <b-row class="align-items-center text-white">
                <b-col cols="6" md="8">
                    {{ $t('cookieLaw') }}
                </b-col>
                <b-col cols="6" md="4" class="text-center">
                    <b-button variant="success" @click="acceptCookie()" pill>{{ $t('accept') }}</b-button>
                    <b-button variant="link" href="/privacy-policy">{{ $t('privacyPolicy') }}</b-button>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
    import { commonService } from "@/services";

    export default {
        name: 'cookie-law',

        data() {
            return {
                showCookie: false
            }
        },

        mounted() {
            this.emitter.on("showCookieLaw", (showCookie) => {
                this.showCookie = showCookie;
            });
        },

        methods: {
            async acceptCookie() {
                await commonService.acceptCookie();

                this.showCookie = false;
            }
        }
    }
</script>
